import React, { useState, useCallback } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import MyTextInput from "../../app/common/form/MyTextInput";
import { Button, Label, Grid, Segment } from "semantic-ui-react";
import { signInWithEmail } from "../../app/firestore/firebaseService";
import { resetPassword } from "./authActions";
import { Link } from "react-router-dom";
import firebase from "../../app/config/firebase";
import { parse, format, addDays, subDays } from "date-fns";
const firestore = firebase.firestore();

export default function LoginForm({ history }) {
    console.log("Rendering LoginForm");
    const [forgot, setForgot] = useState(false);

    function changeType() {
        setForgot(true);
    }
    function changeTypeFalse() {
        setForgot(false);
    }

    return (
        <div className="login_bg">
            <Grid textAlign="center">
                <Grid.Row>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Formik
                            initialValues={{ email: "", password: "" }}
                            validate={(values) => {
                                const errors = {};
                                if (!values.email) {
                                    errors.email = "Required";
                                }
                                if (!forgot && !values.password) {
                                    errors.password = "Required";
                                }
                                return errors;
                            }}
                            onSubmit={async (values, { setSubmitting, setErrors }) => {
                                try {
                                    if (forgot) {
                                        await resetPassword(values.email);
                                        changeTypeFalse();
                                    } else {
                                        await signInWithEmail(values);
                                        let userInfo = await firestore.collection("users").where("email", "==", values.email).get();
                                        if (!userInfo || userInfo.empty) {
                                            await firebase.auth().signOut();
                                            setErrors({ auth: "Account not found. Please contact admin." });
                                            return;
                                        }
                                        const userData = userInfo.docs[0].data();
                                        if (userData?.isDisabled) {
                                            await firebase.auth().signOut();
                                            setErrors({ auth: "Your account is disabled. Please contact admin." });
                                            return;
                                        }
                                        let resetDate = userData.passwordResetDate ? userData.passwordResetDate.toDate() : "";

                                        if (!resetDate || (resetDate && new Date() > new Date(format(addDays(resetDate, 90), "yyyy-MM-dd")))) {
                                            history.push("/password/reset");
                                        } else if (userData.isExternal) {
                                            history.push("/leads/landing");
                                        } else {
                                            history.push("/dashboard/landing");
                                        }
                                    }
                                } catch (error) {
                                    console.log("Login error:", error);
                                    setErrors({ auth: "Problem with username or password" });
                                } finally {
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({ isSubmitting, isValid, dirty, errors, values }) => (
                                <Form className="ui form">
                                    <Segment>
                                        <img src="/assets/logo-login2.png" alt="IGO Travel" style={{ marginTop: -182, marginBottom: 15 }} />
                                        <MyTextInput name="email" placeholder="Email Address" type="text" />
                                        {!forgot && <MyTextInput name="password" placeholder="Password" type="password" />}
                                        <Button
                                            loading={isSubmitting}
                                            disabled={!isValid || !dirty || isSubmitting}
                                            type="submit"
                                            fluid
                                            size="large"
                                            color="orange"
                                            content={forgot ? "Send Reset Link" : "Login"}
                                            style={{ marginTop: "20px", marginBottom: "10px" }}
                                        />
                                        {errors.auth && <Label basic color="red" style={{ marginBottom: 10 }} content={errors.auth} />}
                                    </Segment>
                                </Form>
                            )}
                        </Formik>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column>
                        {!forgot && (
                            <Button style={{ marginTop: 20 }} onClick={changeType}>
                                Forgot password?
                            </Button>
                        )}
                        {forgot && (
                            <Button style={{ marginTop: 20 }} onClick={changeTypeFalse}>
                                Back to Login
                            </Button>
                        )}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    );
}
